import React from 'react';
import {
  FDStack, FDPaper, FDTimeline, FDTimelineItem, FDBodyText,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';
import {
  TaxDashboardWizardNav,
} from 'Views/Page/Content/Modal/Layouts/TaxDashboardWizard/Components/TaxDashboardWizardNav';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

const Layout = () => {
  const { resource } = useMetaLayoutContext();

  const details = resource.attr('detailsCollection') ? resource.attr('detailsCollection').resources().list() : [];

  return (
    <TaxDashboardWizardNav extraNavRelationshipName={fr.relationships.exit.name}>
      <FDStack direction="column" paddingY={4}>
        <FDPaper appearance={'flat'}>
          <FDStack direction={'column'} spacing={4} padding={3}>
            <FDStack direction="column" spacing={2}>
              <MetaControlField attr={'title'} {...dataAttrs('tax-dashboard-review-kickoff-outro-title')} />
              <MetaControlField attr={'body'} {...dataAttrs('tax-dashboard-review-kickoff-outro-subtitle')} />
            </FDStack>

            {details.length && (
              <FDTimeline>
                {details.map((detail, i) => (
                  <FDTimelineItem icon={detail.attr('icon')} isLastItem={i === details.length - 1}>
                    <FDBodyText value={detail.attr('description')} size={'lg'} />
                  </FDTimelineItem>
                ))}
              </FDTimeline>
            )}

          </FDStack>
        </FDPaper>
      </FDStack>
    </TaxDashboardWizardNav>
  );
};

export default Layout;
